// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.me5Nj{display:flex;gap:4px;align-items:center}.SgQkZ{background-color:#ffecef}.RodLD{background-color:#fff0cd}`, "",{"version":3,"sources":["webpack://./src/pages/instamart/campaign/create/widgets/Steps/Keywords/components/BidInputField/BidInputField.module.scss"],"names":[],"mappings":"AAAA,OACI,YAAA,CACA,OAAA,CACA,kBAAA,CAEA,OACI,wBAAA,CAGJ,OACI,wBAAA","sourcesContent":[".footer {\n    display: flex;\n    gap: 4px;\n    align-items: center;\n\n    &Error {\n        background-color: #ffecef;\n    }\n\n    &ZeroBidRangeError {\n        background-color: #fff0cd;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `me5Nj`,
	"footerError": `SgQkZ`,
	"footerZeroBidRangeError": `RodLD`
};
export default ___CSS_LOADER_EXPORT___;
